export const MONOGRAFIA_STORE = 'tcc';
